import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";
import "react-widgets/dist/css/react-widgets.css";
import "react-widgets-virtualized/lib/styles.css";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import momentLocalizer from "react-widgets-moment";
import moment from "moment";
import apm from "utils/ApplicationMonitoring";

moment.locale("en-gb");
momentLocalizer();
const ErrorBoundary = apm.getErrorBoundaryComponent();

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
